import { Stack, Typography } from '@mui/material';
import { HelpFooter } from '@/packages/courses/pages/registration/components/help-footer';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';

interface SuccessDialogProps {
  onClose: () => void;
  institutionName?: string;
  email: string;
}

export const SuccessDialog = ({
  onClose,
  institutionName,
  email,
}: SuccessDialogProps) => {
  return (
    <BaseDialog
      open
      onClose={onClose}
      icon={<Icon name="success" size={54} alt="Sucesso" />}
      title="Inscrição realizada com sucesso!"
    >
      <Stack spacing={3}>
        <Stack spacing={2}>
          <Typography>
            Sua inscrição foi encaminhada para a instituição {institutionName}.
          </Typography>
          <Typography fontWeight="semibold">
            As orientações para concluir sua matrícula serão enviadas para o
            e-mail {email}
          </Typography>
          <Typography>
            Verifique também sua caixa de spam ou lixo eletrônico
          </Typography>
        </Stack>
        <HelpFooter />
      </Stack>
    </BaseDialog>
  );
};
